const urlTicketApi = `${process.env.REACT_APP_ADMINISTRATION_API_URL}ticket?country=MX`

export const createTicket = async (data: any, token: string) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_ADMINISTRATION_XAPIKEY
        },
        body: JSON.stringify(data),
    };
    const urlRequest = `${urlTicketApi}`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};


export const updateTicket = async (data: any, token: string) => {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_ADMINISTRATION_XAPIKEY
        },
        body: JSON.stringify(data),
    };
    const urlRequest = `${urlTicketApi}`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};

